import lazyLoading from '@/core/router/lazy-loading'
import GlobalLayout from '@/core/layouts/global-layout/GlobalLayout'

export const changelogRoutes = [
  {
    path: '/changelog',
    component: GlobalLayout,
    meta: {
      title: 'What\'s New',
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'changelog',
        component: lazyLoading('changelog', 'Changelog'),
      },
    ],
  },
]
